import React from 'react';
import ImagemMaster from 'assets/img/icones/icon-master.png';

const LogoMaster = props => {
  return (<img src={ImagemMaster} width="110" heigth="56" alt="Master" style={{ marginTop: '-9px' }}/>)
};
export default LogoMaster;